import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  editPubmatic,
  loadPubmaticBuyers,
  loadPubmaticViewModel,
  PubmaticBuyer,
  PubmaticViewModel,
  selectPubmaticBuyers,
  selectPubmaticModelById
} from './pubmatic-state';
import {Observable, tap} from 'rxjs';
import {DistributionAccount} from '../../../../distribution-account/distribution-account.model';
import {PubmaticEditConfig} from './account-pubmatic-edit-wrapper.component';

@Injectable({
  providedIn: 'root'
})
export class PubmaticFacadeService {

  constructor(private store: Store) {
  }

  saveChanges(account: DistributionAccount, config: PubmaticEditConfig, originalModel: PubmaticViewModel): void {
    const newBuyers = config.buyers
      .filter(changedBuyer => !originalModel.buyers.includes(changedBuyer))
      .map(changedBuyer => ({
        id: changedBuyer.id,
        type: 'BUYER',
        deleted: false
      }));
    const deletedBuyers = originalModel.buyers
      .filter(originalBuyer => !config.buyers.includes(originalBuyer))
      .map(originalBuyer => ({
        id: originalBuyer.id,
        type: 'BUYER',
        deleted: true
      }));
    this.store.dispatch(editPubmatic({
      request: {
        accountId: account.id,
        pubmaticExternalId: account.foreignIdForCurrentSegment,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        segmentId: account.segmentId!!,
        config: {
          price: config.price,
          buyers: [...newBuyers, ...deletedBuyers]
        }
      }
    }));
  }

  selectModel(pubmaticExternalId: string): Observable<PubmaticViewModel> {
    return this.store.select(selectPubmaticModelById(pubmaticExternalId));
  }

  fetchModel(foreignIdForCurrentSegment: string) {
    this.store.dispatch(loadPubmaticViewModel({pubmaticExternalId: foreignIdForCurrentSegment}));
  }

  selectBuyers(): Observable<PubmaticBuyer[]> {
    return this.store.select(selectPubmaticBuyers)
      .pipe(
        tap(buyers => {
          if (!buyers || buyers.length === 0) {
            this.store.dispatch(loadPubmaticBuyers());
          }
        })
      );
  }
}
